import React, { useEffect, useState } from 'react';
import { Grid, Typography, Box, Skeleton } from '@mui/material';
import { BarChart, CustomButtonGroup } from '../../../shared';
import {
    AFFINITY_SEGMENT,
    AFFINITY_CHART_OPTIONS,
    AFFINITY_CHART_SERIES,
} from './constants';
import { useDispatch, useSelector } from 'react-redux';
import { getAffinityBySegment } from '../../../../redux/thunks/physicanTargetListAnalysisThunk';

function AffinityBySegment(props) {
    const { } = props;
    const [preference, setPreference] = useState(AFFINITY_SEGMENT[0]);
    const dispatch = useDispatch();
    const { company } = useSelector(state => state.company);
    const { affinityBySegment } = useSelector(state => state.physicianTargetListAnalysis)
    const { digitalAffinityChartData, PeerToPeerAffinityChartData, PersonalPromotionAffinityChartData, isLoading } = affinityBySegment;
    useEffect(() => {
        if(company.id){
            dispatch(getAffinityBySegment({companyId: company.id}))
        }
        
    },[company.id])
    return (
        <Box className="box-sizing-border-box br-16px border-1-gray">
            <Box className="flex-column padding-24px border-bottom-gray">
                <Box className="flex-column gap-24">
                    <Box>
                        <Typography className="text-lg-semi-bold gray-900">
                            Affinity By Segment
                        </Typography>
                    </Box>
                    <Box>
                        <CustomButtonGroup
                            data={AFFINITY_SEGMENT}
                            selected={preference}
                            handleClick={(option) => setPreference(option)}
                        />
                    </Box>
                </Box>
            </Box>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Box className="padding-24px height-343px apexchart-horizontal-bar-chart">
                    {isLoading ? <Skeleton variant='rectangular' width={'100%'} height={"300px"}/> :
                        <BarChart
                            chartOptions={
                                {
                                    ...AFFINITY_CHART_OPTIONS,
                                    xaxis: {
                                        ...AFFINITY_CHART_OPTIONS.xaxis, 
                                        categories: preference === "Digital Affinity" ? 
                                        digitalAffinityChartData?.categories : 
                                        preference === "Personal Promotion Affinity" ?
                                        PersonalPromotionAffinityChartData?.categories :
                                        PeerToPeerAffinityChartData?.categories
                                    },
                                }
                            }
                            chartSeries={
                                preference === "Digital Affinity" ? digitalAffinityChartData?.chartSeries
                                : 
                                preference === "Personal Promotion Affinity" ? PersonalPromotionAffinityChartData?.chartSeries
                                :
                                PeerToPeerAffinityChartData?.chartSeries

                            }
                        />
                        }
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}

export default AffinityBySegment;
